import {
    TRANSITION_ENQUIRE,
    TRANSITION_ENQUIRY_ACCEPT,
    TRANSITION_ENQUIRY_ACCEPT_OWNER,
    TRANSITION_ENQUIRY_DECLINE,
    TRANSITION_ENQUIRY_DECLINE_OWNER,
    TRANSITION_ENQUIRY_EXPIRE,
} from './util/transaction';

const { REACT_APP_CANONICAL_ROOT_URL: ROOT_URL } = process.env;

export const NOTIFICATION_FEED_URL_STATE_OPEN_KEY = 'notificationFeedOpen';
export const NOTIFICATION_FEED_URL_STATE_KEY = 'notificationFeedState';
export const NOTIFICATION_FEED_URL_STATE_NAVIGATED_FROM = 'navigatedFrom';

export const CUSTOM_EVENT_UI_TIRE = 'CUSTOM_EVENT_UI_TIRE';

export const NEW_MESSAGE = 'custom_notification_newMessage';
export const NEW_ENTRIES = 'custom_notification_newEntries';
export const NEW_VISITORS = 'custom_notification_newVisitors';
export const NEW_MATCHES = 'custom_notification_newMatches';
export const CREDITS_ALLOCATED = 'custom_notification_creditsAllocated';
export const FLIP_AND_WIN_COUNTER_RESET = 'custom_notification_flipAndWinCounterReset';
export const LOW_BALANCE_REMINDER = 'custom_notification_lowBalanceReminder';
export const CHAT_EXPIRY_REMINDER = 'custom_notification_chatExpiryReminder';
export const AVAILABILITY_STATUS_CONFIRMED = 'availability_status_confirmed';
export const AVAILABILITY_STATUS_NOT_CONFIRMED = 'availability_status_not_confirmed';
export const AVAILABILITY_STATUS_NOT_AVAILABLE = 'availability_status_not_available';
export const SPONSORED_DEALOO = 'sponsored_dealoo';

export const CUSTOM_USER_NOTIFICATION_EVENTS = {
    NEW_MESSAGE,
    NEW_ENTRIES,
    NEW_VISITORS,
    NEW_MATCHES,
    CREDITS_ALLOCATED,
    FLIP_AND_WIN_COUNTER_RESET,
    LOW_BALANCE_REMINDER,
    CHAT_EXPIRY_REMINDER,
    AVAILABILITY_STATUS_CONFIRMED,
    AVAILABILITY_STATUS_NOT_CONFIRMED,
    AVAILABILITY_STATUS_NOT_AVAILABLE,
    SPONSORED_DEALOO,
    TRANSITION_ENQUIRE,
    TRANSITION_ENQUIRY_ACCEPT,
    TRANSITION_ENQUIRY_ACCEPT_OWNER,
    TRANSITION_ENQUIRY_DECLINE,
    TRANSITION_ENQUIRY_DECLINE_OWNER,
    TRANSITION_ENQUIRY_EXPIRE,
};

export const CUSTOM_USER_NOTIFICATION_EVENTS_CONFIG = {
    [NEW_MESSAGE]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
    [NEW_ENTRIES]: { getNotificationLink: ({ link }) => link },
    [NEW_MATCHES]: { getNotificationLink: ({ link }) => link },
    [NEW_VISITORS]: {
        getNotificationLink: () => `${ROOT_URL}/visitors`,
    },
    [CREDITS_ALLOCATED]: {
        getNotificationLink: () => `${ROOT_URL}/balance/history`,
    },
    [LOW_BALANCE_REMINDER]: {
        getNotificationLink: () => `${ROOT_URL}/balance/history`,
    },
    [FLIP_AND_WIN_COUNTER_RESET]: {
        getNotificationLink: () => `${ROOT_URL}/flip-and-win`,
    },
    [CHAT_EXPIRY_REMINDER]: {
        getNotificationLink: () => `${ROOT_URL}/messages`,
    },
    [AVAILABILITY_STATUS_CONFIRMED]: {
        getNotificationLink: () => `${ROOT_URL}/profile/rider/edit?availabilityStatusChange=true`,
    },
    [AVAILABILITY_STATUS_NOT_CONFIRMED]: {
        getNotificationLink: () => `${ROOT_URL}/profile/rider/edit?availabilityStatusChange=true`,
    },
    [AVAILABILITY_STATUS_NOT_AVAILABLE]: {
        getNotificationLink: () => `${ROOT_URL}/profile/rider/edit?availabilityStatusChange=true`,
    },
    [SPONSORED_DEALOO]: {
        getNotificationLink: () => 'https://www.dealoo.ch/de/cmp/TShZYHxKB8fNyTSxNjTvM',
    },
    [TRANSITION_ENQUIRE]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
    [TRANSITION_ENQUIRY_ACCEPT]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
    [TRANSITION_ENQUIRY_ACCEPT_OWNER]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
    [TRANSITION_ENQUIRY_DECLINE]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
    [TRANSITION_ENQUIRY_DECLINE_OWNER]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
    [TRANSITION_ENQUIRY_EXPIRE]: {
        getNotificationLink: ({ transactionId }) =>
            `${ROOT_URL}/messages${transactionId ? `/${transactionId}` : ''}`,
    },
};
